import React, { useState, useEffect } from "react";
import SellerNavbar from "../../component/SellerNavbar";
import SellerSidebar from "../../component/SellerSidebar";
import axios from "axios";
import { baseurl, imageUrl } from "../../Baseurl";
import Swal from "sweetalert2";

const BusinessProfile = () => {
  const [sellerData, setSellerData] = useState({
    business_logo: "",
    business_name: "",
    business_email: "",
    contact: "",
    gst_number: "",
    gst_document: "",
    business_address: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
  });

  const [loading, setLoading] = useState(true);
  const user_id = localStorage.getItem("seller_id");

  useEffect(() => {
    const fetchSellerData = async () => {
      try {
        const response = await axios.get(`${baseurl}getBusinessProfileByUserId/${user_id}`);
        if (response.data && response.data.data) {
          setSellerData(response.data.data);
        }
      } catch (error) {
        console.error("❌ Error fetching business profile:", error);
      } finally {
        setLoading(false);
      }
    };

    if (user_id) {
      fetchSellerData();
    }
  }, [user_id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSellerData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSellerData((prevData) => ({
        ...prevData,
        business_logo: file,
      }));
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      setSellerData((prevData) => ({
        ...prevData,
        business_logo: file,
      }));
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };


  const handleFileChange = (e) => {
    const file = e.target.files[0]; // Get selected file
    setSellerData({ ...sellerData, gst_document: file });
  };

  


  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
  
    const jsonData = { ...sellerData, user_id };
    delete jsonData.business_logo;
  
    formData.append("data", JSON.stringify(jsonData));
  
    if (sellerData.business_logo instanceof File) {
      formData.append("business_logo", sellerData.business_logo);
    }
  
    if (sellerData.gst_document instanceof File) {
      formData.append("gst_document", sellerData.gst_document);
    }
  
    // Debugging: Log formData contents
    console.log("📝 Sent JSON Data:", jsonData);
  
    console.log("📤 Sending FormData:");
    formData.forEach((value, key) => {
      if (value instanceof File) {
        console.log(`📁 FILE - ${key}:`, {
          name: value.name,
          type: value.type,
          size: value.size,
        });
      } else {
        console.log(`🔹 FIELD - ${key}:`, value);
      }
    });
  
    try {
      const response = await axios.post(`${baseurl}uploadBusinessDetails`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
  
      console.log("✅ Server Response:", response.data);
  
      if (response.data.message.includes("successfully")) {
        Swal.fire({
          icon: "success",
          title: "Profile updated successfully",
          text: "Your business profile has been updated.",
        }).then(() => {
          window.location.reload();
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Update Failed",
          text: "Could not update your profile. Please try again.",
        });
      }
    } catch (error) {
      console.error("❌ Error updating seller data:", error);
      Swal.fire({
        icon: "error",
        title: "An error occurred",
        text: "There was an issue with the server. Please try again later.",
      });
    }
  };
  
  return (
    <>
      <SellerNavbar />
      <div>
        <section className="mb-5">
          <div className="container-fluid">
            <div className="row my-3 g-2 justify-content-center">
              <div className="col-md-2">
                <SellerSidebar />
              </div>

              <div className="col-md-10">
                <div className="reviewcls text-start">
                  <h4 className="selh1">Business Profile</h4>
                  <p className="payttl">Update your business information.</p>
                  <hr />

                  {loading ? (
                    <p>Loading...</p>
                  ) : (
                    <form className="contact-form text-start" onSubmit={handleSubmit} encType="multipart/form-data">
                      <div className="row g-2">
                        {/* Business Logo Upload (Drag & Drop) */}
                       

                        {/* Business Name */}
                        <div className="row g-1">
                            <div className="col-md-3"><label className="form-label">Business Name</label></div>
                            <div className="col-md-5">
                            <input type="text" name="business_name" placeholder="Enter Business Name" className="form-control" value={sellerData.business_name} onChange={handleInputChange} required />
                            </div> 
                        </div>

                        <div className="row g-1">
                            <div className="col-md-3"><label className="form-label">Business Email</label></div>
                            <div className="col-md-5">
                            <input type="email" name="business_email" placeholder="Enter Business Email" className="form-control" value={sellerData.business_email} onChange={handleInputChange} required />
                            </div>
                        </div>
 

                        <div className="row g-1">
                            <div className="col-md-3"><label className="form-label">Contact Number</label></div>
                            <div className="col-md-5"><input type="tel" placeholder="Enter Contact Number" name="contact" className="form-control" value={sellerData.contact} onChange={handleInputChange} required /></div>
                        </div>
     

                        <div className="row g-1">
                            <div className="col-md-3"><label className="form-label">GST Number</label></div>
                            <div className="col-md-5"><input type="text" placeholder="Enter GST Number" name="gst_number" className="form-control" value={sellerData.gst_number} onChange={handleInputChange} /></div>
                        </div>

                        <div className="row g-1">
  <div className="col-md-3">
    <label className="form-label">Upload GST Document</label>
  </div>
  <div className="col-md-5">
    <input
      type="file"
      name="gst_document"
      className="form-control"
      accept=".jpg,.jpeg,.png,.pdf"
      onChange={handleFileChange}
    />
    <small>Use upload Format [jpg, jpeg, webp, png, pdf] Only</small>
  </div>

  {/* Show GST Document Download Link If Available */}
  {sellerData.gst_document && (
    <div className="col-md-4 mt-2">
      <a 
        href={`${imageUrl}gst_documents/${sellerData.gst_document}`} 
        download 
        className="btn btn-sm btn-primary"
        target="_blank"
        rel="noopener noreferrer"
      >
        📥 Preview GST Document
      </a>
    </div>
  )}
</div>

                        
                       

                        <div className="row g-1">
                            <div className="col-md-3"><label className="form-label">Business Address</label></div>
                            <div className="col-md-9"><input type="text" placeholder="Enter Business Address" name="business_address" className="form-control" value={sellerData.business_address} onChange={handleInputChange} required /></div>
                        </div>

                         

                        <div className="row g-1">
                            <div className="col-md-3"> </div>
                            <div className="col-md-3"><input type="text" name="city" placeholder="Enter City" className="form-control" value={sellerData.city} onChange={handleInputChange} required /></div>
                            <div className="col-md-3"><input type="text" name="state" placeholder="Enter State" className="form-control" value={sellerData.state} onChange={handleInputChange} required /></div>
                            <div className="col-md-3">
                            <select name="country" className="form-control" value={sellerData.country} onChange={handleInputChange} required>
                            <option value="">Select Country</option>
                            <option value="India">India</option>
                            <option value="USA">United States</option>
                            <option value="China">China</option>
                            <option value="Germany">Germany</option>
                            <option value="UK">United Kingdom</option>
                            <option value="Japan">Japan</option>
                            <option value="Canada">Canada</option>
                            <option value="France">France</option>
                            <option value="Italy">Italy</option>
                            <option value="Mexico">Mexico</option>
                          </select>
                            </div>
                        </div>

                   
  

                        <div className="row g-1">
                            <div className="col-md-3"><label className="form-label">Pincode</label></div>
                            <div className="col-md-3"><input type="text" placeholder="Enter Pincode" name="pincode" className="form-control" value={sellerData.pincode} onChange={handleInputChange} required /></div>
                        </div>


                        <div className="row g-1">
                            <div className="col-md-3"><label className="form-label">Business Logo</label></div>
                            <div className="col-md-3">
                            <div
                            className="dropbox"
                            onDrop={handleDrop}
                            onDragOver={handleDragOver}
                            style={{
                              width: "150px",
                              height: "150px",
                              border: "2px dashed #ccc",
                              borderRadius: "8px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                              overflow: "hidden",
                              position: "relative",
                            }}
                          >
                            <input
                              type="file"
                              accept="image/*"
                              onChange={handleLogoChange}
                              style={{
                                position: "absolute",
                                width: "100%",
                                height: "100%",
                                opacity: 0,
                                cursor: "pointer",
                              }}
                            />
                            {sellerData.business_logo instanceof File ? (
                              <img
                                src={URL.createObjectURL(sellerData.business_logo)}
                                alt="Business Logo"
                                style={{ width: "100%", height: "100%", objectFit: "fill" }}
                              />
                            ) : sellerData.business_logo ? (
                              <img
                                src={`${imageUrl}business_logos/${sellerData.business_logo}`}
                                alt="Business Logo"
                                style={{ width: "100%", height: "100%", objectFit: "fill" }}
                              />
                            ) : (
                              <p style={{ color: "#aaa", textAlign: "center" }}>Drop or Click to Upload</p>
                            )}
                          </div>
                                </div>
                        </div>
                        
                        
                      </div>

                      <div className="mt-3 text-end">
                        <button type="submit" className="btn submitbtnn w-25">
                          Update Profile
                        </button>
                      </div>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default BusinessProfile;
